const map = {
	"./Location.svg": 8230,
	"./arrow-down.svg": 1759,
	"./arrow-left.svg": 5648,
	"./arrow-right.svg": 6415,
	"./arrow_down_circle.svg": 8592,
	"./book_online.svg": 2250,
	"./calendar.svg": 5033,
	"./cancel.svg": 2045,
	"./checkmark.svg": 5058,
	"./discount.svg": 8574,
	"./document.svg": 152,
	"./get_confirmation.svg": 4147,
	"./move.svg": 7680,
	"./secure.svg": 8436,
	"./sit_back_and_relax.svg": 2408,
	"./special_mission.svg": 9791,
	"./standard_cleaning.svg": 5250,
	"./super_clean.svg": 6938
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;